export default "__VITE_ASSET__jxXwUHqR__"